module.exports = __webpack_public_path__ + "media/11.4a528464.wav";